var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { deepmerge } from 'deepmerge-ts';
import { v4 } from 'uuid';
import { Plugin, } from './generics';
import { getSupportedContracts } from './plugins/allowanceRequiredProtocols';
var NewPluginType = /** @class */ (function (_super) {
    __extends(NewPluginType, _super);
    function NewPluginType(args) {
        // @ts-ignore
        var _this = _super.call(this) || this;
        _this.create = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        }); };
        return _this;
    }
    return NewPluginType;
}(Plugin));
export { NewPluginType };
export var createPlugin = function (_a) {
    var getParams = _a.getParams, protocol = _a.protocol, type = _a.type, method = _a.method, isMulticallPlugin = _a.isMulticallPlugin, validate = _a.validate, onCreate = _a.onCreate, onChange = _a.onChange, getSubscribtions = _a.getSubscribtions, name = _a.name, description = _a.description, initParams = _a.initParams, supportedContracts = _a.supportedContracts, falseMeansFail = _a.falseMeansFail, toEns = _a.toEns, getParamsOnCreate = _a.getParamsOnCreate, requiredApprovals = _a.requiredApprovals, calculateValuesOnUserInput = _a.calculateValuesOnUserInput, beforeSimulate = _a.beforeSimulate, setValuesAsync = _a.setValuesAsync, assetFlow = _a.assetFlow, overrideSetMethodParams = _a.overrideSetMethodParams, estimateGasOnParams = _a.estimateGasOnParams, payerIndex = _a.payerIndex, usePureMethod = _a.usePureMethod, flowType = _a.flowType;
    var NewPlugin = /** @class */ (function (_super) {
        __extends(NewPlugin, _super);
        function NewPlugin(args) {
            var _this = this;
            var _a, _b, _c;
            var argsInitParams = args === null || args === void 0 ? void 0 : args.initParams;
            var init = initParams;
            if (argsInitParams) {
                init = deepmerge(initParams, argsInitParams);
            }
            var chainId = (args === null || args === void 0 ? void 0 : args.chainId) || '1';
            var params = getParams({ chainId: chainId, vaultAddress: args === null || args === void 0 ? void 0 : args.vaultAddress, walletAddress: args === null || args === void 0 ? void 0 : args.walletAddress });
            // if(!isMulticallPlugin && type !== 'ACTION' && type !== 'LIBRARY') {
            //   params.input.isOffChainOnly = new FctBoolean({ value: 'false', required: false, virtual: true })
            // }
            _this = _super.call(this, protocol, type, method, name, chainId, params, requiredApprovals, assetFlow, init, args.walletAddress, args.vaultAddress, args.provider, flowType ? flowType : 'ANY') || this;
            _this.create = function () { return __awaiter(_this, void 0, void 0, function () {
                var params, callType, paramsOnCreate, call_1, call;
                var _a, _b, _c, _d;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            params = this.input.get();
                            callType = type === 'ACTION' || type === 'LIBRARY' ? type : 'VIEW_ONLY';
                            if (!getParamsOnCreate) return [3 /*break*/, 2];
                            return [4 /*yield*/, getParamsOnCreate({
                                    chainId: this.chainId,
                                    params: params,
                                })];
                        case 1:
                            paramsOnCreate = _e.sent();
                            if (!paramsOnCreate) {
                                console.log(this.input.errors);
                                return [2 /*return*/];
                            }
                            call_1 = {
                                value: (_a = paramsOnCreate.params.value) === null || _a === void 0 ? void 0 : _a.value,
                                to: (_b = paramsOnCreate.params.to) === null || _b === void 0 ? void 0 : _b.value,
                                toENS: this.toEns,
                                method: paramsOnCreate.method,
                                params: this.getMethodParams({
                                    params: paramsOnCreate.params.methodParams,
                                }),
                                options: {
                                    gasLimit: this.gasLimit || paramsOnCreate.gasLimit || '0',
                                    falseMeansFail: this.falseMeansFail,
                                    payerIndex: this.payerIndex,
                                    usePureMethod: this.usePureMethod,
                                    callType: callType,
                                },
                            };
                            return [2 /*return*/, _super.prototype.create.call(this, { call: call_1 })];
                        case 2:
                            call = {
                                value: (_c = params.value) === null || _c === void 0 ? void 0 : _c.value,
                                to: (_d = params.to) === null || _d === void 0 ? void 0 : _d.value,
                                method: this.method,
                                params: this.methodParams,
                                toENS: this.toEns,
                                options: {
                                    gasLimit: this.gasLimit || '0',
                                    falseMeansFail: this.falseMeansFail,
                                    payerIndex: this.payerIndex,
                                    usePureMethod: this.usePureMethod,
                                    callType: callType,
                                },
                            };
                            return [2 /*return*/, _super.prototype.create.call(this, { call: call })];
                    }
                });
            }); };
            var options = (_a = params.input.to) === null || _a === void 0 ? void 0 : _a.options;
            if (options && options.length) {
                _this._supportedContracts = options.map(function (option) { return ({
                    address: option.value,
                    name: option.name,
                    chainId: option.chainId,
                }); });
                if (options.length === 1) {
                    (_b = _this.input.params.to) === null || _b === void 0 ? void 0 : _b.set({ value: options[0].value });
                }
            }
            else if (supportedContracts) {
                var pluginContracts = getSupportedContracts({ chainId: chainId, contracts: supportedContracts });
                if (pluginContracts && pluginContracts.length === 1)
                    (_c = _this.input.params.to) === null || _c === void 0 ? void 0 : _c.set({ value: pluginContracts[0].value });
                _this._supportedContracts = supportedContracts;
            }
            if (name) {
                _this._name = name;
            }
            _this.toEns = toEns;
            _this.payerIndex = payerIndex;
            if (validate)
                _this.input.validate = validate;
            if (description)
                _this._description = description;
            if (getSubscribtions)
                getSubscribtions({
                    chainId: _this.chainId,
                    input: _this.input.params,
                    output: _this.output.params,
                    setMethod: _this.setMethod,
                    walletAddress: args.walletAddress,
                    vaultAddress: args.vaultAddress,
                }).forEach(function (subscription) {
                    _this.input.subscribe(subscription);
                });
            if (onCreate) {
                onCreate({ chainId: chainId, input: _this.input.params, output: _this.output.params });
            }
            if (setValuesAsync) {
                _this.setValuesAsync = setValuesAsync;
            }
            if (onChange) {
                _this.input.subscribe({
                    callback: function () { return onChange({ chainId: chainId, input: _this.input.params, output: _this.output.params }); },
                    id: v4(),
                });
            }
            if (calculateValuesOnUserInput) {
                _this.calculateValuesOnUserInput = calculateValuesOnUserInput({
                    chainId: chainId,
                    input: _this.input.params,
                    output: _this.output.params,
                    account: args.vaultAddress,
                    provider: _this.provider,
                    setMethod: _this.setMethod,
                });
            }
            if (overrideSetMethodParams) {
                _this.setMethodParams = overrideSetMethodParams({
                    chainId: chainId,
                    input: _this.input.params,
                    output: _this.output.params,
                });
            }
            if (beforeSimulate) {
                _this.beforeSimulate = beforeSimulate;
            }
            if (estimateGasOnParams) {
                _this.estimateGasOnParams = estimateGasOnParams;
            }
            if (getParamsOnCreate) {
                _this.getParamsOnCreate = getParamsOnCreate;
            }
            if (falseMeansFail)
                _this._falseMeansFail = falseMeansFail;
            if (usePureMethod)
                _this._usePureMethod = usePureMethod;
            return _this;
        }
        return NewPlugin;
    }(Plugin));
    return NewPlugin;
};
